export const formatNumber = function (number) {
	number = parseFloat(number.toFixed(2));
	return number.toLocaleString('cs-CZ',  {maximumFractionDigits: 2, minimumFractionDigits: 2});
	//number = number.toFixed(2);
	//return number.replace('.', ',');
}

export const renderItems = function (children) {
	var result = '';

	children.forEach(function (child) {

		var items = '';

		child.items.forEach(function (item) {
			items += `<div class="cart-reca-single row">
		                            <a href="${item.url}" class="cart-reca-single-href large-10 medium-10 small-10 columns">
		                                                                                                                                    <span class="cr-pic"><img src="${getCdnImageUrl(`/user/shop/related/${item.image}`)}" alt="${item.name}"></span>
		                                <span class="cr-name" data-testid="cartWidgetProductName">
		                                    <small data-testid="cartWidgetProductAmount">1x</small>
		                                    ${item.name}
		                                                                                                        </span>
		                                <span class="cr-price" data-testid="cartWidgetProductPrice">${formatNumber(item.price*item.quantity)} Kč</span>
		                            </a>
		                            
		                            <form action="#" class="mini-cart-sub-delete large-2 medium-2 small-2 columns" method="post">
                                          <fieldset>
                                             <input type="submit" value="x" class=" b-delete small button tiny" aria-label="Odstranit z košíku">
                                             <input type="hidden" value="${item.id}" class="item-id" />
                                          </fieldset>
                                       </form>

                                                                                       
                                                    </div> <div class="clear">&nbsp;</div>`;
		})

		result += `<div class="cart-reca-single row">
                             <strong>${child.childName}</strong>
                             </div>                                                  
                             ${items}
                        `;
	})

	return result;
}

export const recalculate = function (price, quantity) {
	return formatNumber(price * quantity);
};

export const isCartStep = function (step) {
	var query = new URLSearchParams(location.search)
	var currentStep = parseInt(query.get('step') || 1)
	return currentStep === step;
}

export const roundTwoDecimals = function (number) {
	return  Math.round(number*10)/10;
}

export const formatDate = function (value) {
	var date = new Date(value);
	var day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
	var month = (date.getMonth() + 1) < 10 ? `0${(date.getMonth() + 1)}` : (date.getMonth() + 1);
	var year = date.getFullYear();

	return day + "." + month + "." + year;
}

export const getCdnImageUrl = function (path) {
	var domain = window.location.hostname;
	path = path.startsWith('/') ? path.substr(1) : path
	return `https://cdn.myshoptet.com/usr/${domain}/${path.replace(/^\/+\/\/+$/g, '')}`;
}